import { useMemo } from 'react';

import { NotificationCenterItem } from 'react-toastify/addons/use-notification-center';

import { INotification } from '@c/notifications/types';

export const useVisibleNotifications = (
  notifications: NotificationCenterItem<INotification>[],
  showUnreadOnly: boolean
) => {
  return useMemo(
    () => (showUnreadOnly ? notifications.filter((item) => !item.read) : notifications),
    [notifications, showUnreadOnly]
  );
};
